import React, { useEffect, useState } from "react";
import apiRequest from "../../functions/api";
import {
    Typography,
    Grid,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    FormControlLabel,
    Checkbox,
    Button,
    useMediaQuery,
} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import { fetchFile } from "../../pages/TransferHistory/fetchFile";
import openFile from "../../components/shared/functions/download";
import axios from "axios";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { API_BASE_URL } from '../../constants/apiConstants';



function Personalinformation(props) {
    const { t } = useTranslation();
    const { user, accessToken, bearbeitung, client, daten, setReload } = props
    const [isLoading, setIsLoading] = useState(false);
    const [dateiData, setDateiData] = useState([]);
    var fileName = "";
    const [priv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
    const { showErrorMessage, showSuccessMessage } = useMessage();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const program = "LWEB02"

    //Technische Funktionen

    useEffect(() => {
        setDateiData(daten.dateien)
    }, [daten])

    const handleOpenFile = (file, ffe3_key) => {
        setIsLoading(true);
        fileName = file;
        const payload = {
            mandant: client,
            program: program,
            statement: "DATEI_AUS_DMS",
            mandant: user.md,
            personalnummer: user.pnr,
            userId: user.id,
            dockey: ffe3_key
        };
        const headers = {
            Authorization: "Bearer " + accessToken,
        };
        handleDownload("daten", payload, headers, datencb, errorCb);
    }

    async function handleDownload(path, payload, headers, callback, errorcallback) {
        axios.defaults.withCredentials = true;
        await axios.post(API_BASE_URL + path, payload, { withCredentials: true, headers: headers, responseType: 'blob' })
            .then(response => {
                callback(response);
            })
            .catch(async function (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        console.log('Token abgelaufen');
                        await auth.logout();
                        // refresh the page for them
                        window.location.reload();
                    } else {
                        callback(error.response);
                    }
                } else {
                    console.log(error);
                    if (errorcallback) {
                        errorcallback();
                    }
                }
            }
            );
    };

    const datencb = (response) => {
        setIsLoading(false)
        if (response.status === 200) {
            const fileContent = response.data
            openFile(fileName, fileContent, response.headers['content-type'])

        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    };

    const errorCb = (response) => {
        if (response) {
            showErrorMessage(t(response.data.message));
        } else {
            showErrorMessage(t("Keine Internetverbindung"));
        }
    };

    // Anzeige Funktionen
    const dateienAnzeigen = () => {
        return (
            <TableContainer>
                <Table>

                    <TableBody>

                        {dateiData && dateiData.Datei && Object.entries(dateiData.Datei).map(([ffe3, file]) => {
                            const returnableObject = (
                                <TableRow key={ffe3}>
                                    <TableCell align="left">

                                        <Typography variant="body2">
                                            {t(file)}{t(dateiData.Endung[ffe3])}
                                        </Typography>


                                    </TableCell>
                                    <TableCell align="right">


                                        <IconButton
                                            color="primary"
                                            onClick={() =>
                                                handleOpenFile(file+dateiData.Endung[ffe3], ffe3)
                                            }
                                        >
                                            <VisibilityIcon />
                                        </IconButton>


                                    </TableCell>

                                </TableRow>
                            )
                            return returnableObject

                        })}
                        {!dateiData &&
                            <TableRow key={"Keine Dateien"}>
                                <TableCell align="left">
                                    <Typography>{t("Keine Einsehbaren Dateien gefunden")}</Typography>
                                </TableCell>
                            </TableRow>

                        }


                    </TableBody>
                </Table>
            </TableContainer>
        )
    }


    return (
        <>
            {isLoading ? (
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            ) :
                (
                    <Grid item>
                        <Grid container spacing={0.5}>
                            <Grid item xs={12}>
                                <Paper>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ArrowDownwardIcon />}
                                        >
                                            <Typography>{t("Hinterlegte Dateien")}</Typography>

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {dateienAnzeigen()}
                                        </AccordionDetails>
                                    </Accordion>

                                </Paper>
                            </Grid>

                        </Grid>

                    </Grid>


                )}
        </>
    )
}



export default Personalinformation